import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled, { css } from 'styled-components';

const FADE_WIDTH = 72;
const BUTTON_SIZE = 28;

// Always visible, as macOS otherwise hides overflow scrollbars until you scroll.
export const visibleScrollbar = css`
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.grey[400]};
    border-radius: 3px;
  }
`;

// Lets the fades and buttons overlay the row without taking space from it.
export const ScrollViewport = styled.div`
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
`;

// Solid for the outer half, then fading: white items on a near-white page barely show a plain gradient.
export const EdgeFade = styled.div<{
  $side: 'left' | 'right';
  $visible: boolean;
  $height: number;
}>`
  position: absolute;
  top: 0;
  ${({ $side }) => $side}: 0;
  width: ${FADE_WIDTH}px;
  height: ${({ $height }) => $height}px;
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 150ms ease;

  background: linear-gradient(
    to ${({ $side }) => ($side === 'left' ? 'right' : 'left')},
    ${({ theme }) => theme.palette.grey[100]} 0%,
    ${({ theme }) => theme.palette.grey[100]} 50%,
    transparent 100%
  );
`;

export const ScrollButton = styled.button<{
  $side: 'left' | 'right';
  $visible: boolean;
  $height: number;
}>`
  position: absolute;
  ${({ $side }) => $side}: 2px;
  top: ${({ $height }) => ($height - BUTTON_SIZE) / 2}px;
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  padding: 0;
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background-color: ${({ theme }) => theme.palette.common.white};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }
`;

const chevron = css`
  font-size: 20px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
  ${chevron}
`;

export const StyledChevronRightIcon = styled(ChevronRightIcon)`
  ${chevron}
`;
